// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"Page404_PageWrapper__3OwjD","Page":"Page404_Page__2E2wh","MainPageLink":"Page404_MainPageLink__3Te-N"};